<script setup lang="ts">
import { ArrowRight, Rocket } from '@lucide/vue';
import { Button } from '@/components/ui/button';
</script>

<template>
    <section class="py-16 sm:py-20">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div
                class="bg-card border-border flex flex-col items-center gap-6 rounded-3xl border p-8 text-center sm:p-12"
            >
                <span
                    class="bg-primary/10 text-primary inline-flex size-12 items-center justify-center rounded-full"
                >
                    <Rocket class="size-6" aria-hidden="true" />
                </span>

                <h2
                    class="font-display max-w-2xl text-3xl leading-[1.15] text-balance sm:text-4xl"
                >
                    Ready to put your marketing on autopilot?
                </h2>

                <p class="text-muted-foreground max-w-xl text-lg">
                    Join the early access list and be there on day one, before
                    registration opens.
                </p>

                <Button as-child size="lg">
                    <a href="#early-access">
                        Join early access
                        <ArrowRight class="size-4" aria-hidden="true" />
                    </a>
                </Button>

                <p class="text-muted-foreground text-xs">
                    Invite only while we finish building. We will not share your
                    details.
                </p>
            </div>
        </div>
    </section>
</template>
